// ID for the main content area used by a11y-skip-to-content navigation
export const MAIN_CONTENT_ID = 'main-content';
